import PropTypes from 'prop-types';
import {useIdleTimer} from 'react-idle-timer';

// Isolates useIdleTimer so scroll/activity events only re-render this gate, not App.
// react-idle-timer updates internal state on activity (e.g. scroll), which would otherwise re-render App.
function IdleTimerGate({onIdle, children}) {
  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 120, // 2 hours in milliseconds
    throttle: 1000 * 10, // Check every 10 seconds
    events: [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'click',
      'keypress',
    ],
  });
  return children;
}

IdleTimerGate.propTypes = {
  onIdle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default IdleTimerGate;
